export enum EnquirySiteVisitStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export const EnquirySiteVisitStatusMap: Record<
  string,
  { label: string; color: string }
> = {
  [EnquirySiteVisitStatus.NEW]: { label: "New", color: "primary" },
  [EnquirySiteVisitStatus.IN_PROGRESS]: {
    label: "In progress",
    color: "primary",
  },
  [EnquirySiteVisitStatus.COMPLETED]: { label: "Completed", color: "success" },
  [EnquirySiteVisitStatus.CANCELLED]: { label: "Cancelled", color: "danger" },
};

export enum EnquirySiteVisitPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export const EnquirySiteVisitPriorityMap: Record<
  string,
  { label: string; color: string }
> = {
  [EnquirySiteVisitPriority.LOW]: { label: "Low", color: "secondary" },
  [EnquirySiteVisitPriority.MEDIUM]: { label: "Medium", color: "warning" },
  [EnquirySiteVisitPriority.HIGH]: { label: "High", color: "danger" },
};

/** scheduleVia from employee work schedule (site visit rows) */
export const SiteVisitScheduleViaMap: Record<
  string,
  { label: string; description: string }
> = {
  ENQUIRY_ASSIGNMENT: {
    label: "Enquiry team",
    description: "You are assigned to the enquiry this visit belongs to.",
  },
  SITE_VISIT_ASSIGNMENT: {
    label: "Visit assignment",
    description: "You are directly assigned to this site visit.",
  },
};
